export default __webpack_public_path__ + "static/adelie-ipad-035502055ea8ec4c0c97dca1b2608eb6.png";